import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FormValidationService {
    moveToInvalidTab() {
        const activeTabId: string | undefined = document.querySelector('#nav-tab-content .active.show')?.id;
        // find first tab with error
        let errorTabId: string | undefined;
        for (let i = 0; i < 5; i++) {
            if (document.querySelector(`#t-${i} .ng-invalid`)) {
                errorTabId = `t-${i}`;
                break;
            }
        }

        if (errorTabId !== activeTabId && errorTabId && activeTabId) {
            // switch to error tab
            document.getElementById(`${errorTabId!}-tab`)?.classList?.add('active');
            document.getElementById(errorTabId!)?.classList?.add('active', 'show');

            // remove class from old active tab
            document.getElementById(`${activeTabId!}-tab`)?.classList?.remove('active');
            document.getElementById(activeTabId!)?.classList?.remove('active', 'show');
        }
    }
}
